import { Button, Grid, TextField } from '@mui/material'
import { FC, useCallback, useState } from 'react'
import LoginIcon from '@mui/icons-material/Login'
import { UseGetUser } from '../../API'

const NotFound: FC = () => {
  //const user = () => Number(localStorage.getItem('user')) || 0;
  const [login, setLogin] = useState<string>('')
  const [pass, setPass] = useState<string>('')
  const [isLogonError, setIsLogonError] = useState<boolean>()

  const handleLog = useCallback(async () => {
    const isLogon = await UseGetUser(login, pass)

    if (isLogon) {
      setIsLogonError(true)
      localStorage.setItem('user', JSON.stringify(isLogon))

      window.location.href = '/roomsList'
    } else {
      setIsLogonError(false)
      localStorage.setItem('user', JSON.stringify(isLogon))
    }
  }, [login, pass])

  return (
    <Grid
      container
      //justify="center"
      alignItems='center'
      direction='column'
      style={{ paddingTop: 20, minHeight: '100vh' }}
      spacing={1}
    >
      <Grid item xs={12} style={{ alignContent: 'center' }}>
        <img width={230} src='img/DoorLock.jpg' alt={'logo'} />
      </Grid>
      <Grid item xs={12} style={{ alignContent: 'center', color: '#e75050' }}>
        {isLogonError === false ? 'nepareizs lietotājs / parole' : <br />}
      </Grid>
      <Grid item xs={12} style={{ alignContent: 'center' }}>
        <TextField
          //sx={{ marginTop: 2 }}
          label={'Lietotājs'}
          size={'small'}
          fullWidth
          variant='outlined'
          value={login}
          onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            setLogin(event.target.value)
          }}
        />
      </Grid>
      <Grid item xs={12} style={{ alignContent: 'center' }}>
        <TextField
          //sx={{ marginTop: 2 }}
          label={'Parole'}
          size={'small'}
          fullWidth
          variant='outlined'
          value={pass}
          type='password'
          onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            setPass(event.target.value)
          }}
        />
      </Grid>
      <Grid item xs={12} style={{ alignContent: 'center' }}>
        <Button
          //sx={{ marginTop: 2 }}
          onClick={handleLog}
          fullWidth
          variant='contained'
          color={'success'}
          endIcon={<LoginIcon />}
        >
          {'Pieslēgties'}
        </Button>
      </Grid>
    </Grid>
  )
}

export default NotFound
